import { InteractionButton, ToolbarButtonGroup } from "../../lib/ui/toolbar/buttons";
export class LandListSelectButton extends InteractionButton {
    constructor() {
        super('map', 'Select parcels in Polygon (Land List)', 'landButton', 'Land List', ToolbarButtonGroup.Group);
        this.set_interaction('land');
    }
}
